module.exports = __webpack_public_path__ + "static/media/gb-sct.9b0857fc.svg";